import React, {memo} from "react";
import {css} from "@emotion/react";

import {ph, w100} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {PaginationSize, PaginationWithList} from "@pg-design/pagination";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useIsMobile} from "@pg-mono/hooks";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    comparisonMode?: boolean;
    gtmData: {
        listingName: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles: React.FC<IProps> = memo((props) => {
    const {pageCount, onPageChange, page, filterRequestState, requestState, properties} = props.propertyListObj;
    const isMobile = useIsMobile();
    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, props.filterValues);
        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList
                requestState={filterRequestState}
                properties={properties}
                offer={props.offer}
                comparisonMode={props.comparisonMode}
                css={propertyListWrapper}
                gtmData={props.gtmData}
            />
            {pageCount > 0 && (
                <PaginationWithList
                    iconPrev={<ChevronLeftIcon />}
                    iconNext={<ChevronRightIcon />}
                    onChangePageClick={handlePageChange}
                    requestState={requestState}
                    pageCount={pageCount}
                    currentPage={page.currentPage}
                    multiNumbersInside
                    size={isMobile ? PaginationSize.XS : PaginationSize.SM}
                />
            )}
        </>
    );
});

const propertyListWrapper = css`
    padding-left: 0 !important;
    padding-right: 0 !important;

    > ul {
        ${ph(0)};
        ${w100};
    }
`;
import React, {memo} from "react";
import {css} from "@emotion/react";

import {ph, w100} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {PaginationSize, PaginationWithList} from "@pg-design/pagination";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useIsMobile} from "@pg-mono/hooks";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    comparisonMode?: boolean;
    gtmData: {
        listingName: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles: React.FC<IProps> = memo((props) => {
    const {pageCount, onPageChange, page, filterRequestState, requestState, properties} = props.propertyListObj;
    const isMobile = useIsMobile();
    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, props.filterValues);
        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList
                requestState={filterRequestState}
                properties={properties}
                offer={props.offer}
                comparisonMode={props.comparisonMode}
                css={propertyListWrapper}
                gtmData={props.gtmData}
            />
            {pageCount > 0 && (
                <PaginationWithList
                    iconPrev={<ChevronLeftIcon />}
                    iconNext={<ChevronRightIcon />}
                    onChangePageClick={handlePageChange}
                    requestState={requestState}
                    pageCount={pageCount}
                    currentPage={page.currentPage}
                    multiNumbersInside
                    size={isMobile ? PaginationSize.XS : PaginationSize.SM}
                />
            )}
        </>
    );
});

const propertyListWrapper = css`
    padding-left: 0 !important;
    padding-right: 0 !important;

    > ul {
        ${ph(0)};
        ${w100};
    }
`;
